export default __webpack_public_path__ + "static/media/gummies1.9a64e642.png";